import React, { FC, useEffect, useState } from 'react';
import { daysOfWeek, PeriodSchedule } from './ScheduleTypes';
import moment from 'moment';

type PeriodSchedulePreviewPropsType = {
  periodId: string;
  periodSchedule: PeriodSchedule;
  setActivePeriodIdEditing: (periodId: string | null) => void;
};

const PeriodSchedulePreview: FC<PeriodSchedulePreviewPropsType> = ({
  periodId,
  periodSchedule,
  setActivePeriodIdEditing,
}) => {
  // const [allHolidays, setAllHolidays] = useState<any[]>([]);

  // useEffect(() => {
  //   const holidaysList = JSON.parse(localStorage.getItem('holidaysList') || '[]') || [];
  //   if (holidaysList.length === 0) {
  //     setAllHolidays([]);
  //   } else {
  //     setAllHolidays(holidaysList);
  //   }
  // }, [periodSchedule]);
  // console.log(periodSchedule.holidays);
  return (
    <div className="w-full">
      <div className="w-full rounded-lg border-1 border-gray-200 bg-gray-50">
        <div className="w-full flex justify-start items-center p-1 py-3 border-gray-200 whitespace-nowrap">
          <span className="text-1419 bg-white rounded-md mr-3 ml-2 px-4 py-3 text-neutralBlack opacity-70">
            <span className="font-bold text-2xl">{periodSchedule.name}</span>
          </span>
          <span className="text-1419 bg-white rounded-md mr-0 ml-2 px-4 py-3 text-gray-600 opacity-70">
            <span className="font-bold">
              {moment(periodSchedule.startDate).format('MM/DD/YYYY')}
            </span>
          </span>
          <span className="text-1419 bg-white rounded-md mr-0 ml-2 py-3 text-gray-600 opacity-70">
            <span className="font-bold">-</span>
          </span>
          <span className="text-1419 bg-white rounded-md mr-3 ml-2 px-4 py-3 text-gray-600 opacity-70">
            <span className="font-bold">{moment(periodSchedule.endDate).format('MM/DD/YYYY')}</span>
          </span>
          <span className="ml-auto mr-1">
            <span
              className="my-1 px-4 py-1 mr-2 text-xlg font-bold inline-block rounded-md w-32 bg-persianBlue hover:bg-blue text-white hover:text-gray-100 cursor-pointer transition-all duration-300 whitespace-nowrap align-center text-center"
              onClick={() => setActivePeriodIdEditing(periodId)}
            >
              Edit
            </span>
          </span>
        </div>
      </div>
      <div className="w-full rounded-lg border-1 border-gray-200 bg-gray-50 p-5 mt-3 pl-7">
        <div className="text-1624 font-bold">Schedule Summary</div>
        <div>
          {periodSchedule.applyToAllORs
            ? 'Same Schedule for all ORs'
            : 'Different Schedule for each OR'}
        </div>
        <div className="flex flex-row-reverse">
          <div className="shadow-lg ml-auto h-[400px] -mt-16">
            <div className="font-bold p-3 border-0 bg-slate-500 text-2xl pl-6 text-gray-50 rounded-t-2xl">
              Holidays
            </div>
            <div className="h-[360px] overflow-y-auto py-3 px-2">
              {periodSchedule.holidays?.map((holiday, idx) => (
                <div key={idx}>
                  <div className="p-1 px-3 mb-1">
                    <div className="font-bold mr-2 -mb-2 text-gray-600">{holiday.name}</div>
                    <div className="text-gray-400">{moment(holiday.date).format('MM/DD/YYYY')}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="overflow-x-auto whitespace-nowrap w-[47vw] mr-5">
            {Object.entries(periodSchedule.schedule)
              .filter(([orId, schedule]) => {
                if (periodSchedule.applyToAllORs) return orId === 'AllORs';
                else return orId !== 'AllORs';
              })
              .map(([orId, schedule]) => (
                <div
                  key={orId}
                  className={`m-3 ml-0 bg-white rounded-main border-1 border-gray-200 inline-block w-[250px]`}
                >
                  <h3 className="font-bold p-3 border-0 bg-blue text-2xl pl-6 text-gray-50 rounded-t-main">
                    {orId === 'AllORs' ? 'All ORs' : orId}
                  </h3>
                  <div className="p-4">
                    {daysOfWeek
                      .filter((d) => d !== 'All')
                      .map((day, idx) => {
                        const daySched = schedule[day];
                        return daySched ? (
                          <div key={day}>
                            <div
                              // className="grid grid-cols-3 gap-3 border-b border-gray-200"
                              className={`grid grid-cols-3 gap-3 border-b border-gray-200 text-gray-600 ${
                                idx % 2 !== 0 ? 'bg-gray-50' : 'bg-white'
                              }`}
                            >
                              <span className="mr-2 p-3">{day}</span>
                              <span className="font-bold p-3">
                                {daySched?.checked ? daySched?.startTime : '-'}
                              </span>
                              <span className="font-bold p-3">
                                {daySched?.checked ? daySched?.endTime : '-'}
                              </span>
                            </div>
                          </div>
                        ) : (
                          <div key={day}>Error</div>
                        );
                      })}
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeriodSchedulePreview;
